import { useEffect, useRef } from 'react'
import { LeftOutlined } from '@ant-design/icons'
import styles from './index.module.scss'
import Utils from '@utils/utils'

const statusMap = {
    approved: { label: '可用', className: 'approved' },
    rejected: { label: '需修改', className: 'rejected' },
    modified: { label: '已修改', className: 'modified' },
}

// 常见视频扩展名，用于判断 url 是否为视频资源
const VIDEO_EXTENSIONS = /\.(mp4|webm|ogg|mov|avi|mkv|flv|wmv|m4v)(\?|$)/i

/** 根据 url 扩展名判断是否为视频 */
function isVideoUrl(url) {
    if (!url) return false
    return VIDEO_EXTENSIONS.test(url)
}

export default function PicViewerLeft ({
    onCancel,
    images = [],
    currentIndex = 0,
    onSelect,
}) {
    const listRef = useRef(null)
    const itemRefs = useRef([])

    useEffect(() => {
        const el = itemRefs.current[currentIndex]
        if (el && listRef.current) {
            el.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
        }
    }, [currentIndex])

    return (
        <div className={styles.PicViewerLeft}>
            <div className={styles.CloseButton} onClick={onCancel}>
                <LeftOutlined />
                <span>返回</span>
            </div>
            <div className={styles.Progress}>
                第{currentIndex + 1}/{images.length}张
            </div>
            <div className={styles.ThumbnailList} ref={listRef}>
                {images.map((img, index) => {
                    const status = statusMap[img.status]
                    return (
                        <div
                            key={index}
                            ref={el => itemRefs.current[index] = el}
                            className={`${styles.ThumbnailItem} ${index === currentIndex ? styles.active : ''}`}
                            onClick={() => onSelect?.(index)}
                        >
                            {
                                isVideoUrl(img.url) ?
                                <img src={Utils.getVideoSnapshot(img.url)} alt="" className={styles.ThumbnailImg} /> :
                                <img src={Utils.getImgThumbnail(img.url)} alt="" className={styles.ThumbnailImg} />
                            }
                            {status && (
                                <span className={`${styles.StatusBadge} ${styles[status.className]}`}>
                                    {status.label}
                                </span>
                            )}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
